import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import ServiceCarts from "../../components/service-carts/ServiceCarts";

function ServiceCartsPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Service Carts | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title={"Service Carts"} t={t} />
      <ServiceCarts />
    </>
  );
}

export default ServiceCartsPage;
